// file: src/routes/LandlordRoutes.jsx
import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import LandlordSignIn from "../LandlordPages/LandlordSignIn";
import ProtectedRoute from "../components/routing/ProtectedRoute";
import { useAuth } from "../auth/AuthContext";
import DashboardShell from "../LandlordPages/DashboardLayout";

// Existing pages
import LandlordPasswordResetRequest from "../LandlordPages/LandlordForgotPassword";
import LandlordResetPassword from "../LandlordPages/LandlordResetPassword";
import LandlordLookup from "../LandlordPages/LandlordLookup";
import AllBookings from "../LandlordPages/AllBookings";

function LandlordLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  return (
    <LandlordSignIn
      onSignIn={(payload) => {
        login(payload, true);
        const from = location.state?.from?.pathname || "/landlord/dashboard";
        navigate(from, { replace: true });
      }}
    />
  );
}

function LandlordProtectedLayout() {
  const { logout } = useAuth();
  return (
    <ProtectedRoute redirectTo="/landlord/signin">
      <DashboardShell onLogout={logout}>
        <Outlet />
      </DashboardShell>
    </ProtectedRoute>
  );
}

export default function LandlordRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="signin" element={<LandlordLoginPage />} />
      <Route path="password-reset" element={<LandlordPasswordResetRequest />} />
      <Route
        path="reset-password/reset-password"
        element={<LandlordResetPassword />}
      />
      <Route path="reset-password" element={<LandlordResetPassword />} />

      {/* Protected area */}
      <Route element={<LandlordProtectedLayout />}>
        <Route path="dashboard" element={<LandlordLookup />} />
        {/* ⬇️ NEW: All Bookings route */}
        <Route path="all-bookings" element={<AllBookings />} />
        <Route index element={<Navigate to="dashboard" replace />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/landlord/signin" replace />} />
    </Routes>
  );
}
